/* eslint-disable react/jsx-no-comment-textnodes */
/* eslint-disable no-unused-vars */
import React from "react";
import { HiArrowNarrowRight } from "react-icons/hi";
import { Link } from "react-router-dom";
import LazyLoad from "react-lazy-load";

const Skill = ({ mainSkill }) => {
  return (
    <article
      aria-label="main skills"
      name="skill's"
      className="w-full text-gray-200 bg-slate-800/70 backdrop-blur-sm backdrop-brightness-50 backdrop-sepia"
    >
      {/* containner */}
      <div className="flex flex-col justify-center w-full h-full p-6 mx-auto max-w-7xl">
        <div>
          <h2 className="inline text-4xl font-bold border-b-4 rounded border-cyan-600">
            {"Skills"}
          </h2>
          <p aria-label="Technologies" className="py-4 text-sm">
            {
              "These are the Technologies i mainly worked with and still learning them."
            }
          </p>
        </div>
        <div className="grid w-full grid-cols-2 gap-4 py-10 text-center sm:grid-cols-3 md:grid-cols-4">
          {mainSkill.map((skill) => (
            <figure
              aria-label={skill.name}
              key={skill.id}
              className="px-2 py-6 rounded-lg shadow-lg shadow-slate-900 group"
            >
              <LazyLoad>
                <img
                  src={skill.icon}
                  className="w-20 group-hover:scale-125 duration-500  h-20 pt-1.5 mx-auto"
                  alt={skill.name}
                />
              </LazyLoad>
              <p aria-label={skill.name} className="my-4">
                {skill.name}
              </p>
            </figure>
          ))}

          <div></div>
          <div className="hidden sm:flex"></div>
          <Link
            to="skills"
            className="flex justify-center p-2 rounded-lg shadow-lg shadow-slate-900 hover:bg-cyan-900 group"
          >
            <button
              type="button"
              className="flex items-center px-6 py-3 duration-500 rounded-xl group-hover:scale-125"
            >
              View More
              <HiArrowNarrowRight
                aria-label="see more"
                size={26}
                className="ml-5 duration-700 group-hover:animate-ping "
              />
            </button>
          </Link>
        </div>
      </div>
    </article>
  );
};

export default Skill;
